export function productMock(ids) {
  if (ids[0] === 'GROUPING-34641') {
    return {
      success: true,
      products: ids,
      entities: {
        shippingMethods: {
          '5246': {
            id: 2016,
            type: 'onDemand',
            min: 39.99,
            max: 60,
            fee: 4.99,
            desc: {
              expected: 'Delivery under an hour',
            },
            deliveryExpectation: 'Delivery under an hour',
            deliveryHours: {
              sun: [['12:00', '19:45']],
              mon: [['10:00', '20:45']],
              tue: [['10:00', '20:45']],
              wed: [['10:00', '20:45']],
              thu: [['10:00', '20:45']],
              fri: [['10:00', '20:45']],
              sat: [['10:00', '20:45']],
            },
          },
          '8808': {
            id: 8808,
            type: 'shipped',
            min: 15,
            max: 7200,
            fee: 9.99,
            desc: {
              expected: 'Usually ships within 1-2 business days',
            },
            deliveryExpectation: 'Usually ships within 1-2 business days',
            deliveryHours: {
              sun: [['00:00', '23:59']],
              mon: [['00:00', '23:59']],
              tue: [['00:00', '23:59']],
              wed: [['00:00', '23:59']],
              thu: [['00:00', '23:59']],
              fri: [['00:00', '23:59']],
              sat: [['00:00', '23:59']],
            },
          },
        },
        addresses: {
          '3433784': {
            id: 3433784,
            address1: '420 Kent Ave',
            address2: null,
            city: 'Brooklyn',
            stateName: 'NY',
            zipCode: '11249',
            latitude: 40.7100012,
            longitude: -73.96905029999999,
          },
          '3986195': {
            id: 3986195,
            address1: '1866 Old Country Rd.',
            address2: null,
            city: 'Riverhead',
            stateName: 'NY',
            zipCode: '11901',
            latitude: 40.9242833,
            longitude: -72.7101399,
          },
        },
        retailers: {
          '3751': {
            id: 3751,
            name: 'Kent Wines & Liquors',
            address: 3433784,
            shippingMethods: [5246],
          },
          '5501': {
            id: 5501,
            name: 'BevMax NY',
            address: 3986195,
            shippingMethods: [8808],
          },
        },
        products: {
          'GROUPING-34641': {
            name: 'Liquid Magic Elixir Double Cask',
            brand: 'Liquid',
            description:
              "Deliciously smooth, with rich dried fruits and sherry, balanced with woodsmoke and spice. Described by Max Stose, the renowned international whisky writer, in his book Kindred Spirits as 'simply the best 12 Year Old single malt around'.\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, serunt mollit anim id est laborum.\nUt enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip\n",
            descriptionHtml:
              "Deliciously smooth, with rich dried fruits and sherry, balanced with woodsmoke and spice. Described by Max Stose, the renowned international whisky writer, in his book Kindred Spirits as 'simply the best 12 Year Old single malt around'.<br>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, serunt mollit anim id est laborum.<br>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip",
            category: 'Spirits',
            type: 'Whiskey',
            images: [
              'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/Liquid-Bottle-1.png',
              'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/Liquid-Bottle-2.jpg',
              'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/Liquid-Bottle-3.jpg',
              'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/Liquid-Bottle-4.jpg',
            ],
            isSuppressed: false,
            variants: [
              {
                productId: 2691,
                size: '750ml, bottle',
                images: [
                  'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/Liquid-Bottle-1.png',
                ],
                packSize: '',
                availability: ['onDemand', 'shipped', 'engraved'],
                engravingConfigs: {
                  active: true,
                  characters: 16,
                  lines: 3,
                  location: ['Back of the Bottle'],
                },
                retailers: [
                  {
                    variantId: 14243621,
                    retailer: 3751,
                    type: 'onDemand',
                    price: '114.99',
                    inStock: 20,
                    engraving: false,
                    customerPlacement: 'standard',
                    shippingMethod: 5246,
                  },
                  {
                    variantId: 14243621,
                    retailer: 3751,
                    type: 'onDemand',
                    price: '114.99',
                    inStock: 20,
                    engraving: false,
                    customerPlacement: 'standard',
                    shippingMethod: 5246,
                  },
                  {
                    variantId: 11453735,
                    retailer: 5501,
                    type: 'shipped',
                    price: '97.99',
                    inStock: 16,
                    engraving: true,
                    customerPlacement: 'standard',
                    shippingMethod: 8808,
                  },
                  {
                    variantId: 11453735,
                    retailer: 5501,
                    type: 'engraved',
                    price: '97.99',
                    inStock: 16,
                    engraving: true,
                    customerPlacement: 'standard',
                    shippingMethod: 8808,
                  },
                ],
              },
              {
                productId: 2692,
                size: '1L, bottle',
                images: [
                  'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/Liquid-Bottle-1.png',
                ],
                packSize: '',
                availability: ['onDemand', 'shipped'],
                engravingConfigs: {
                  active: true,
                  characters: 16,
                  lines: 3,
                  location: ['Back of the Bottle'],
                },
                retailers: [
                  {
                    variantId: 14243622,
                    retailer: 3751,
                    type: 'onDemand',
                    price: '214.99',
                    inStock: 20,
                    engraving: false,
                    customerPlacement: 'standard',
                    shippingMethod: 5246,
                  },
                  {
                    variantId: 11453736,
                    retailer: 5501,
                    type: 'shipped',
                    price: '117.99',
                    inStock: 16,
                    engraving: true,
                    customerPlacement: 'standard',
                    shippingMethod: 8808,
                  },
                ],
              },
              {
                productId: 2693,
                size: '1.75L, bottle',
                images: [
                  'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/Liquid-Bottle-1.png',
                ],
                packSize: '',
                availability: ['onDemand', 'shipped'],
                engravingConfigs: {
                  active: true,
                  characters: 16,
                  lines: 3,
                  location: ['Back of the Bottle'],
                },
                retailers: [
                  {
                    variantId: 14243623,
                    retailer: 3751,
                    type: 'onDemand',
                    price: '234.99',
                    inStock: 20,
                    engraving: false,
                    customerPlacement: 'standard',
                    shippingMethod: 5246,
                  },
                  {
                    variantId: 114537353,
                    retailer: 5501,
                    type: 'shipped',
                    price: '137.99',
                    inStock: 16,
                    engraving: true,
                    customerPlacement: 'standard',
                    shippingMethod: 8808,
                  },
                ],
              },
              {
                productId: 2694,
                size: '375ml, bottle',
                images: [
                  'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/Liquid-Bottle-1.png',
                ],
                packSize: '',
                availability: ['onDemand', 'shipped'],
                engravingConfigs: {
                  active: true,
                  characters: 16,
                  lines: 3,
                  location: ['Back of the Bottle'],
                },
                retailers: [
                  {
                    variantId: 14243613,
                    retailer: 3751,
                    type: 'onDemand',
                    price: '34.99',
                    inStock: 20,
                    engraving: false,
                    customerPlacement: 'standard',
                    shippingMethod: 5246,
                  },
                  {
                    variantId: 114537313,
                    retailer: 5501,
                    type: 'shipped',
                    price: '37.99',
                    inStock: 16,
                    engraving: true,
                    customerPlacement: 'standard',
                    shippingMethod: 8808,
                  },
                ],
              },
              {
                productId: 2695,
                size: '6 pack, 12 pack',
                images: [
                  'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/Liquid-Bottle-1.png',
                ],
                packSize: '',
                availability: ['onDemand', 'shipped'],
                engravingConfigs: {
                  active: true,
                  characters: 16,
                  lines: 3,
                  location: ['Back of the Bottle'],
                },
                retailers: [
                  {
                    variantId: 14243113,
                    retailer: 3751,
                    type: 'onDemand',
                    price: '64.99',
                    inStock: 20,
                    engraving: false,
                    customerPlacement: 'standard',
                    shippingMethod: 5246,
                  },
                  {
                    variantId: 114537133,
                    retailer: 5501,
                    type: 'shipped',
                    price: '67.99',
                    inStock: 16,
                    engraving: true,
                    customerPlacement: 'standard',
                    shippingMethod: 8808,
                  },
                ],
              },
            ],
          },
        },
      },
      decisionUUID: '5d6a9f2f-3c06-4421-b080-72cca06f8efb',
    };
  }
  return {
    success: true,
    products: ['BUNDLE-200000041'],
    entities: {
      shippingMethods: {
        '644': {
          id: 644,
          type: 'shipped',
          min: 25,
          max: 14400,
          fee: 19.99,
          desc: {
            expected: 'Usually ships within 1-2 business days',
          },
          deliveryExpectation: 'Usually ships within 1-2 business days',
          deliveryHours: {
            sat: [['00:00', '23:59']],
            sun: [['00:00', '23:59']],
            mon: [['00:00', '23:59']],
            tue: [['00:00', '23:59']],
            wed: [['00:00', '23:59']],
            thu: [['00:00', '23:59']],
            fri: [['00:00', '23:59']],
          },
        },
      },
      addresses: {
        '1070338': {
          id: 1070338,
          address1: '40 Cold Spring Road',
          address2: null,
          city: 'Syosset',
          stateName: 'NY',
          zipCode: '11791',
          latitude: 40.8259145,
          longitude: -73.5009943,
        },
      },
      retailers: {
        '410': {
          id: 410,
          name: 'Wine Cellar',
          address: 1070338,
          shippingMethods: [644],
        },
      },
      products: {
        'BUNDLE-200000041': {
          name: 'The Liquid Magic Elixir Finest in Town 3 Bottle Bundle Collection',
          brand: 'Liquid',
          description: '',
          descriptionHtml:
            "<p>Deliciously smooth, with rich dried fruits and sherry, balanced with woodsmoke and spice. Described by Max Stose, the renowned international whisky writer, in his book Kindred Spirits as 'simply the best 12 Year Old single malt around'.</p><br/><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, serunt mollit anim id est laborum. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip</p>",
          category: 'Spirits',
          type: 'Whiskey',
          subType: '',
          images: [
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-1.png',
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-3.png',
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-4.png',
          ],
          isSuppressed: false,
          bundleConfigs: {
            component_product_data: [
              {
                product_id: 41110,
                quantity: 1,
              },
              {
                product_id: 28525,
                quantity: 1,
              },
              {
                product_id: 207157,
                quantity: 1,
              },
              {
                product_id: 166020,
                quantity: 1,
              },
              {
                product_id: 207157,
                quantity: 2,
              },
              {
                product_id: 207157,
                quantity: 1,
              },
            ],
          },
          variants: [
            {
              productId: 41110,
              name: 'The Liquid Magic Elixir Blue Finest in Town',
              size: '750ml, bottle',
              images: [
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
              ],
              packSize: '',
              availability: ['shipped'],
              engravingConfigs: {
                active: true,
                characters: 16,
                lines: 3,
                location: ['Between the Labels'],
              },
              retailers: [
                {
                  variantId: 1954335,
                  retailer: 410,
                  type: 'shipped',
                  price: '79.99',
                  inStock: 58,
                  engraving: false,
                  customerPlacement: 'standard',
                  shippingMethod: 644,
                },
              ],
            },
            {
              productId: 28525,
              name: 'The Liquid Magic Elixir Red Finest in Town',
              size: '500 ml, bottle',
              images: [
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-3.png',
              ],
              packSize: '',
              availability: ['shipped'],
              engravingConfigs: {
                active: true,
                characters: 16,
                lines: 3,
                location: ['Between the Labels'],
              },
              retailers: [
                {
                  variantId: 1953227,
                  retailer: 410,
                  type: 'shipped',
                  price: '39.99',
                  inStock: 12,
                  engraving: false,
                  customerPlacement: 'standard',
                  shippingMethod: 644,
                },
              ],
            },
            {
              productId: 207157,
              name: 'The Liquid Magic Elixir Green Finest Town',
              size: '350ml, bottle',
              images: [
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-4.png',
              ],
              packSize: '',
              availability: ['shipped'],
              engravingConfigs: {
                active: true,
                characters: 16,
                lines: 3,
                location: ['Side of the Bottle'],
              },
              retailers: [
                {
                  variantId: 1946959,
                  retailer: 410,
                  type: 'shipped',
                  price: '79.99',
                  inStock: 24,
                  engraving: false,
                  customerPlacement: 'standard',
                  shippingMethod: 644,
                },
              ],
            },
            {
              productId: 166020,
              name: 'The Liquid Magic Elixir Blue Finest in Town',
              size: '750ml, bottle',
              images: [
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
              ],
              packSize: '',
              availability: ['shipped'],
              engravingConfigs: {
                active: true,
                characters: 16,
                lines: 1,
                location: ['Above the Label'],
              },
              retailers: [
                {
                  variantId: 4160844,
                  retailer: 410,
                  type: 'shipped',
                  price: '64.99',
                  inStock: 6,
                  engraving: false,
                  customerPlacement: 'standard',
                  shippingMethod: 644,
                },
              ],
            },
            {
              productId: 207157,
              name: 'The Liquid Magic Elixir Green Finest Town',
              size: '350ml, bottle',
              images: [
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-4.png',
              ],
              packSize: '',
              availability: ['shipped'],
              engravingConfigs: {
                active: true,
                characters: 16,
                lines: 3,
                location: ['Side of the Bottle'],
              },
              retailers: [
                {
                  variantId: 1946959,
                  retailer: 410,
                  type: 'shipped',
                  price: '79.99',
                  inStock: 24,
                  engraving: false,
                  customerPlacement: 'standard',
                  shippingMethod: 644,
                },
              ],
            },
          ],
        },
      },
    },
    decisionUUID: 'bca08d83-ad69-4f0c-ab57-1a35ceb285ef',
  };
}
